import { ProviderEnum } from '@dynamic-labs/sdk-api';

const getMagicLinkApiKeyFromProviders = (providers) => {
    const [magicLinkProvider] = providers.filter(({ provider }) => provider === ProviderEnum.MagicLink);
    return magicLinkProvider === null || magicLinkProvider === void 0 ? void 0 : magicLinkProvider.providerProjectId;
};

export { getMagicLinkApiKeyFromProviders };
